// https://thednp.github.io/bootstrap.native/
import Boostrap from './vendor/bootstrap-native-4.1.2/bootstrap-native-esm';

export default function() {
  document.querySelectorAll('.accordion').forEach((accordion) => {
    accordion.querySelectorAll('h5 > a').forEach((collapse) => {
      new Boostrap.Collapse(
        collapse,
        {
          parent: '#'+accordion.getAttribute('id')
        }
      );
    });
    // this replace manual collapse class settings
    if (accordion.querySelector('[data-show="initial"]')) {
      accordion.querySelectorAll('[data-show="initial"]').forEach(el => el.click());
    }
  });
}
